import { AbstractControl, ValidatorFn } from "@angular/forms";

export function VerifyIntelListName(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!control.value) return null;

    // Only A–Z, a–z, 0–9, _ and -
    const regex = /^[a-zA-Z0-9_-]+$/;

    return regex.test(control.value) ? null : { invalidName: true };
  };
}
